import { createAuthClient } from "better-auth/react";
import type { User, Session } from "./auth-types";

// Get base URL and ensure it doesn't have trailing slashes or /api prefix
const getBaseURL = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
  // Remove trailing slashes
  const cleanUrl = baseUrl.replace(/\/+$/, '');
  // Remove /api suffix if present (better-auth is mounted at /auth, not /api/auth)
  const urlWithoutApi = cleanUrl.replace(/\/api$/, '');
  return urlWithoutApi + '/auth';
};

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
});

// Export specific methods for easier use
export const { signIn, signUp, signOut, useSession, resetPassword, requestPasswordReset } = authClient;

// Back-compat: some older code referenced forgotPassword; map it to requestPasswordReset.
export const forgotPassword = (authClient as any).forgotPassword ?? requestPasswordReset;

// Export types
export type { User, Session };

